<template>
  <div class="auth-page">
    <div class="auth-wrapper auth-v1">
      <div class="auth-inner">
        <v-card class="auth-card">
          <v-card-title class="d-flex align-center justify-center py-7">
            <router-link
              to="/"
              class="d-flex align-center"
            >
              <v-img
                :src="logoUrl"
                :alt="empresaName"
                max-width="90"
                contain
              />
            </router-link>
          </v-card-title>

          <slot />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import ligdataLogoLight from '@/assets/images/logos/ligdata-logo-light.png'
import ligdataLogoDark from '@/assets/images/logos/ligdata-logo-dark.png'
import conectaLogo from '@/assets/images/logos/BetEnviosTransp.png'

export default {
  computed: {
    empresaName() {
      return process.env.VUE_APP_EMPRESA_ID == 1 ? 'LigData' : 'BetEnvios'
    },

    logoUrl() {
      if (process.env.VUE_APP_EMPRESA_ID != 1) return conectaLogo

      return this.$vuetify.theme.dark ? ligdataLogoDark : ligdataLogoLight
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
